<template>
  <div class="c-conetntsText">
    <c-input-v2
      :name="requestItem.name"
      :maxlength="requestItem.optionJson.max"
      :minlength="requestItem.optionJson.min"
      :required="requestItem.requiredFlag"
      :placeholder="requestItem.optionJson.placeholder"
      v-model="inputValue"
      @input="changeInput"
      @validate="validateInput"
    />
  </div>
</template>
<script>
export default {
  name: 'ConetntsText',
  props: {
    requestItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inputValue: '',
      isValid: false
    }
  },
  methods: {
    changeInput() {
      this.$emit('change', {
        name: this.requestItem.name,
        value: this.inputValue,
        isValid: this.isValid
      })
    },
    validateInput(isValid) {
      this.isValid = isValid
    }
  }
}
</script>
<style lang="scss" scoped>
.c-conetntsText {
  /deep/ input {
    padding-left: 12px;
    font-size: 14px;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-conetntsText {
    /deep/ input {
      height: 40px;
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-conetntsText {
    /deep/ input {
      height: 48px;
    }
  }
}
</style>
